import React from "react";
import $ from "jquery";

class BootstrapPage extends React.Component {
  componentDidMount() {
    // Tooltip
    $(() => {
      $('[data-toggle="tooltip"]').tooltip();
      $(".data-toggle-tooltip").tooltip();
      $(".data-toggle-tooltip").on("click", () => {
        $(".data-toggle-tooltip").tooltip("hide");
      });
    });

    // Popover & Toast
    $(() => {
      $('[data-toggle="popover"]').popover({
        html: true,
      });
      $(".toast").toast();
    });

    // File select
    $(() => {
      // We can attach the `fileselect` event to all file inputs on the page
      $(document).on("change", ":file", () => {
        const input = $(this);
        const numFiles = input.get(0).files ? input.get(0).files.length : 1;
        const label = input.val().replace(/\\/g, "/").replace(/.*\//, "");
        input.trigger("fileselect", [numFiles, label]);
      });
      // We can watch for our custom `fileselect` event like this
      $(document).ready(() => {
        $(":file").on("fileselect", (event, numFiles, label) => {
          const input = $(this).parents(".input-group").find(":text");
          const log = numFiles > 1 ? `${numFiles} files selected` : label;
          if (input.length) {
            input.val(log);
          } else if (log) {
            // eslint-disable-next-line no-alert
            alert(log);
          }
        });
      });
    });
  }

  render() {
    return (
      <>
        <section className="container develop-content pt-5" id="content">
          <div className="row">
            <div className="col">
              <h1>Bootstrap - Anglian Water - Project viewer</h1>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col">
              <h2 id="colors">Colors</h2>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <div className="colors pt-4">
                <h5>AutoDesk grayscale &amp; primary color</h5>
                <div className="row">
                  <div className="col-lg-3">
                    <ul className="color-black">
                      <li></li>
                      <li className="color">$black</li>
                      <li className="ich">$black-ich</li>
                      <li className="light">$black-light</li>
                      <li className="lighter">
                        $black-lighter<code>Text</code>
                        <i className="fa fa-font"></i>
                      </li>
                      <li className="ultralight text-white">
                        $black-ultralight
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-3">
                    <ul className="color-gray">
                      <li></li>
                      <li className="color">
                        $gray<i className="fa fa-star"></i>
                      </li>
                      <li className="ich">$gray-ich</li>
                      <li className="light">$gray-light</li>
                      <li className="lighter">$gray-lighter</li>
                      <li className="ultralight">$gray-ultralight</li>
                    </ul>
                  </div>
                  <div className="col-lg-3">
                    <ul className="color-light-gray">
                      <li className="dark">$light-gray-dark</li>
                      <li className="color">$light-gray</li>
                      <li className="ich">$light-gray-ich</li>
                      <li className="light">$light-gray-light</li>
                      <li className="lighter">$light-gray-lighter</li>
                      <li className="ultralight">$light-gray-ultralight</li>
                    </ul>
                  </div>
                  <div className="col-lg-3">
                    <ul className="color-primary">
                      <li className="dark">$primary-dark</li>
                      <li className="color">
                        $primary<code>primary</code>
                        <i className="fa fa-star"></i>
                      </li>
                      <li className="ich">$primary-ich</li>
                      <li className="light">
                        $primary-light<i className="fa fa-star"></i>
                      </li>
                      <li className="lighter">$primary-lighter</li>
                      <li className="ultralight">$primary-ultralight</li>
                    </ul>
                  </div>
                </div>
                <h5>Anglian Water colors</h5>
                <div className="row">
                  <div className="col-lg-4">
                    <ul className="color-purple">
                      <li className="color white-color">$purple</li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul className="color-blue">
                      <li className="color white-color">$blue</li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul className="color-blue-light">
                      <li className="color white-color">$blue-light</li>
                    </ul>
                  </div>
                </div>
                <h5>Validation colors</h5>
                <div className="row">
                  <div className="col-lg-4">
                    <ul className="color-danger">
                      <li className="color white-color">
                        $danger<code>danger</code>
                        <i
                          className="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        ></i>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul className="color-success">
                      <li className="color white-color">
                        $success<code>success</code>
                        <i
                          className="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        ></i>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul className="color-warning">
                      <li className="color white-color">
                        $warning<code>warning</code>
                        <i
                          className="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        ></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col">
              <h2 id="typography">Typography</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam
                vitae volutpat elit. Fusce non nunc in metus cursus ornare quis
                aliquet sapien. Morbi lacus lorem, ullamcorper vitae orci et,
                vestibulum fringilla urna.
              </p>
              <p>
                In ac luctus felis, vitae porttitor urna. In eleifend aliquet
                sapien, vitae congue odio. Nullam non turpis sollicitudin nisl
                faucibus vulputate.
              </p>
            </div>
            <div className="col-lg-6">
              <p>
                Curabitur leo nunc, tristique et tempus nec, ultrices et ex.
                Nulla ultricies elit vulputate feugiat malesuada. Pellentesque
                rhoncus a massa quis venenatis. In rutrum malesuada interdum.
              </p>
              <p>
                Nullam vitae volutpat elit. Fusce non nunc in metus cursus
                ornare quis aliquet sapien. Morbi lacus lorem, ullamcorper vitae
                orci et, vestibulum fringilla urna. In ac luctus felis, vitae
                porttitor urna. In eleifend aliquet sapien, vitae congue odio.
              </p>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-lg-6">
              <h1>h1. Heading</h1>
              <h2>h2. Heading</h2>
              <h3>h3. Heading</h3>
              <h4>h4. Heading</h4>
              <h5>h5. Heading</h5>
              <h6>h6. Heading</h6>

              <div className="mb-3">
                <div className="font-size-xs">Font-size-xs</div>
                <div className="font-size-sm">Font-size-sm</div>
                <div className="font-size-base">Font-size-base</div>
                <div className="font-size-lg">Font-size-lg</div>
                <div className="font-size-xl">Font-size-xl</div>
              </div>
            </div>
            <div className="col-lg-6">
              <h3>Standard paragraph heading h3</h3>
              <p className="lead">
                This is lead paragraph, sagittis lacus vel augue laoreet rutrum
                faucibus dolor auctor.
              </p>
              <p>
                The standard paragraph, lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                exercitation ullamco laboris.
              </p>
              <p>
                Sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris.
              </p>
              <div className="line-height-base">Line Height Base 24px</div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <h3>Lists</h3>

              <ul>
                <li>Unordered list</li>
                <li>
                  Unordered list
                  <ul>
                    <li>Nested unordered list</li>
                    <li>Nested unordered list</li>
                  </ul>
                </li>
                <li>
                  Unordered list
                  <ul className="list-unstyled">
                    <li>Nested unordered list unstyled</li>
                    <li>Nested unordered list unstyled</li>
                  </ul>
                </li>
                <li>Unordered list</li>
              </ul>
              <ol>
                <li>Ordered list</li>
                <li>
                  Ordered list
                  <ul className="list-unstyled">
                    <li>Nested unordered list unstyled</li>
                    <li>Nested unordered list unstyled</li>
                    <li>Nested unordered list unstyled</li>
                  </ul>
                </li>
                <li>Ordered list</li>
                <li>Ordered list</li>
              </ol>
              <dl>
                <dt>Description list</dt>
                <dd>A description list is perfect for defining terms.</dd>
                <dt>Description list</dt>
                <dd>A description list is perfect for defining terms.</dd>
                <dt>Description list</dt>
                <dd>A description list is perfect for defining terms.</dd>
              </dl>
            </div>
            <div className="col-lg-6">
              <h3>Inline text</h3>
              <ul className="list-unstyled">
                <li>
                  This line has <a href="/">inline link</a>, how a default link
                  is displayed.
                </li>
                <li>
                  You can use the mark tag to <mark>highlight</mark> text.
                </li>
                <li>
                  This is <small className="text-muted">muted text</small>
                </li>
                <li>
                  <del>
                    This line of text is meant to be treated as deleted text.
                  </del>
                </li>
                <li>
                  <s>
                    This line of text is meant to be treated as no longer
                    accurate.
                  </s>
                </li>
                <li>
                  <ins>
                    This line of text is meant to be treated as an addition to
                    the document.
                  </ins>
                </li>
                <li>
                  <u>This line of text will render as underlined</u>
                </li>
                <li>
                  <small>
                    This line of text is meant to be treated as fine print.
                  </small>
                </li>
                <li>
                  <strong>This line rendered as bold text.</strong>
                </li>
                <li>
                  <em>This line rendered as italicized text.</em>
                </li>
                <li>
                  This is <abbr title="attribute">attr</abbr>
                </li>
                <li>
                  This is abbreviations{" "}
                  <abbr
                    title="HyperText Markup Language"
                    className="initialism"
                  >
                    HTML
                  </abbr>
                </li>
                <li>
                  Variables <var>y</var> = <var>m</var>
                  <var>x</var> + <var>b</var>
                </li>
                <li>
                  This is sup and sub <sup>Penguins</sup> and °Climate* CO
                  <sub>2</sub>
                </li>
                <li>
                  User inputs looks like this{" "}
                  <kbd>
                    <kbd>ctrl</kbd> + <kbd>,</kbd>
                  </kbd>
                </li>
                <li>
                  The <code>code</code> element.
                </li>
                <li>
                  <pre>
                    <code>
                      &lt;p&gt;This is how code blocks is displayed&lt;/p&gt;
                    </code>
                  </pre>
                </li>
              </ul>

              <blockquote className="blockquote">
                <p className="mb-0">
                  Blockquote, adipiscing elit. Integer posuere lorem.
                </p>
                <footer className="blockquote-footer">
                  Someone famous in{" "}
                  <cite title="Source Title">Source Title</cite>
                </footer>
              </blockquote>

              <blockquote className="blockquote">
                <p className="mb-0">
                  Blockquote-reverse, consectetur adipiscing ipsum.
                </p>
                <footer className="blockquote-footer">
                  Someone famous in{" "}
                  <cite title="Source Title">Source Title</cite>
                </footer>
              </blockquote>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col">
              <h2 id="table">Table</h2>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <table className="table table-responsive">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Header content</th>
                    <th>Header content</th>
                    <th>Header content</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                </tbody>
              </table>

              <h3 id="tables-small">Table small</h3>

              <table className="table table-sm table-responsive">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Header content</th>
                    <th>Header content</th>
                    <th>Header content</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                </tbody>
              </table>

              <h3 id="tables-striped">Table striped & table hover</h3>

              <table className="table table-striped table-hover table-responsive">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Header content</th>
                    <th>Header content</th>
                    <th>Header content</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Column content</td>
                    <td>Column content</td>
                    <td>Column content</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col">
              <h2 id="navigation">Navigation</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <h4>Nav tabs</h4>
              <div className="mb-4">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <a className="nav-link active" href="/">
                      Active
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/">
                      Link
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/">
                      Link
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link disabled" href="/">
                      Disabled
                    </a>
                  </li>
                </ul>
              </div>

              <h4>Nav pills</h4>
              <div className="mb-4">
                <ul className="nav nav-pills">
                  <li className="nav-item">
                    <a className="nav-link" href="/">
                      Link
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link active" href="/">
                      Active
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/">
                      Link
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link disabled" href="/">
                      Disabled
                    </a>
                  </li>
                </ul>
              </div>

              <h4>Nav pills Stacked (flex-column)</h4>
              <div className="mb-4">
                <ul className="nav nav-pills flex-column">
                  <li className="nav-item">
                    <a className="nav-link" href="/">
                      Link
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link active" href="/">
                      Active
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/">
                      Link
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link disabled" href="/">
                      Disabled
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <h4>Breadcrumb</h4>
              <div className="mb-4">
                <nav className="breadcrumb">
                  <a className="breadcrumb-item" href="/">
                    Start
                  </a>
                  <a className="breadcrumb-item" href="/">
                    Library
                  </a>
                  <a className="breadcrumb-item" href="/">
                    Data
                  </a>
                  <span className="breadcrumb-item active">Lorem ipsum</span>
                </nav>
              </div>

              <h4>Pagination</h4>

              <nav aria-label="...">
                <ul className="pagination">
                  <li className="page-item disabled">
                    <a
                      className="page-link"
                      href="/"
                      tabIndex="-1"
                      aria-label="Previous"
                    >
                      <span>Previous</span>
                    </a>
                  </li>
                  <li className="page-item active">
                    <a className="page-link" href="/">
                      1 <span className="sr-only">(current)</span>
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="/">
                      2
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="/">
                      3
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="/" aria-label="Next">
                      <span>Next</span>
                    </a>
                  </li>
                </ul>
              </nav>

              <h4>Accordion</h4>

              <div id="accordion" className="accordion">
                <div className="card">
                  <div className="card-header" id="headingOne">
                    <a
                      className=""
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                      href="/"
                    >
                      Collapsible Item 1
                    </a>
                  </div>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      <p>
                        Some quick lorem ipsum example text to build on the card
                        title and make up the bulk of the cards content.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="headingTwo">
                    <a
                      className="collapsed"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                      href="/"
                    >
                      Collapsible Item 2
                    </a>
                  </div>
                  <div
                    id="collapseTwo"
                    className="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      <p>
                        Some quick lorem ipsum example text to build on the card
                        title and make up the bulk of the cards content.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="headingThree">
                    <a
                      className="collapsed"
                      data-toggle="collapse"
                      data-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                      href="/"
                    >
                      Collapsible Item 3
                    </a>
                  </div>
                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      <p>
                        Some quick lorem ipsum example text to build on the card
                        title and make up the bulk of the cards content.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <h4>Navbar</h4>

              <nav className="navbar navbar-dark navbar-expand-lg">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-auto">
                      <header>
                        <a href="./" className="logotype" role="banner">
                          Logotype
                        </a>
                      </header>
                    </div>
                    <button
                      className="navbar-toggler"
                      type="button"
                      data-toggle="collapse"
                      data-target="#navbarExample"
                      aria-controls="navbarSupportedContent"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <i className="fa fa-bars" aria-hidden="true"></i>
                    </button>
                    <div className="col">
                      <div
                        className="collapse navbar-collapse"
                        id="navbarExample"
                      >
                        <div className="navbar-nav pt-2 pr-3">
                          <ul className="nav">
                            <li className="nav-item active">
                              <a className="nav-link" href="/">
                                Navigation
                              </a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="/">
                                Link
                              </a>
                            </li>
                            <li className="nav-item dropdown">
                              <a
                                className="nav-link dropdown-toggle"
                                href="/"
                                id="navbarDropdown"
                                role="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                Dropdown
                              </a>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                aria-labelledby="navbarDropdown"
                              >
                                <a className="dropdown-item" href="/">
                                  Action
                                </a>
                                <a className="dropdown-item" href="/">
                                  Another action
                                </a>
                                <a className="dropdown-item" href="/">
                                  Something else here
                                </a>
                              </div>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="/">
                                Link
                              </a>
                            </li>
                          </ul>
                        </div>
                        <form className="form-inline search">
                          <div className="input-group input-group-sm">
                            <input
                              className="form-control form-control-sm"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                            />
                            <div className="input-group-append">
                              <button
                                className="btn btn-sm btn-primary"
                                type="submit"
                              >
                                Search
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col">
              <h2 id="list-group">List group</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4">
              <div className="list-group">
                <a href="/" className="list-group-item">
                  Lorem ipsum dolor sit amet
                </a>
                <a href="/" className="list-group-item active">
                  Active list group item
                </a>
                <a href="/" className="list-group-item">
                  Lorem ipsum
                </a>
                <a href="/" className="list-group-item">
                  Lorem ipsum dolor sit
                </a>
                <a href="/" className="list-group-item disabled">
                  Disabled list group item
                </a>
                <a href="/" className="list-group-item">
                  Lorem ipsum dolor sit amet
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="list-group">
                <a
                  href="/"
                  className="list-group-item list-group-item-action d-flex justify-content-between active"
                >
                  Active list group item{" "}
                  <span className="badge badge-primary badge-pill badge-sm">
                    14
                  </span>
                </a>
                <a
                  href="/"
                  className="list-group-item list-group-item-action d-flex justify-content-between"
                >
                  Lorem ipsum{" "}
                  <span className="badge badge-primary badge-pill badge-sm">
                    3
                  </span>
                </a>
                <a
                  href="/"
                  className="list-group-item list-group-item-action d-flex justify-content-between"
                >
                  Lorem ipsum dolor sit{" "}
                  <span className="badge badge-primary badge-pill badge-sm">
                    1
                  </span>
                </a>
                <a
                  href="/"
                  className="list-group-item list-group-item-action d-flex justify-content-between"
                >
                  Lorem ipsum dolor sit amet
                </a>
                <a
                  href="/"
                  className="list-group-item list-group-item-action d-flex justify-content-between"
                >
                  Lorem ipsum
                </a>
                <a
                  href="/"
                  className="list-group-item list-group-item-action d-flex justify-content-between"
                >
                  Lorem ipsum dolor sit
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="list-group">
                <a href="/" className="list-group-item list-group-item-action">
                  <h4 className="list-group-item-heading">
                    List group item heading
                  </h4>
                  <p className="list-group-item-text">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor.
                  </p>
                </a>
                <a
                  href="/"
                  className="list-group-item list-group-item-action active"
                >
                  <h4 className="list-group-item-heading">
                    Active list group heading
                  </h4>
                  <p className="list-group-item-text">
                    Lorem ipsum dolor sit amet, consectetur adipiscing.
                  </p>
                </a>
                <a href="/" className="list-group-item list-group-item-action">
                  <h4 className="list-group-item-heading">
                    List group item heading
                  </h4>
                  <p className="list-group-item-text">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do.
                  </p>
                </a>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col">
              <h2 id="buttons">Buttons</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8">
              <h4>Button</h4>
              <div className="mb-3 demo-child">
                <button type="button" className="btn btn-primary">
                  <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                  Primary
                </button>
                <button type="button" className="btn btn-secondary">
                  <i className="fa fa-paper-plane" aria-hidden="true"></i>
                  Secondary (Standard)
                </button>
                <button type="button" className="btn btn-secondary active">
                  <i className="fa fa-rocket" aria-hidden="true"></i>Secondary
                  (active)
                </button>
              </div>

              <h4>Button disabled</h4>
              <div className="mb-3 demo-child">
                <button type="button" className="btn btn-secondary disabled">
                  <i className="fa fa-paper-plane" aria-hidden="true"></i>
                  Secondary
                </button>
                <button type="button" className="btn btn-info disabled">
                  <i className="fa fa-info-circle" aria-hidden="true"></i>Info
                </button>
                <button type="button" className="btn btn-primary disabled">
                  <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                  Primary
                </button>
                <button type="button" className="btn btn-warning disabled">
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  ></i>
                  Warning
                </button>
                <button type="button" className="btn btn-danger disabled">
                  <i className="fa fa-bolt" aria-hidden="true"></i>Danger
                </button>
              </div>

              <h4>Dropdowns</h4>
              <div className="mb-3 demo-child">
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-secondary dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Dropdown
                  </button>
                  <div className="dropdown-menu">
                    <a className="dropdown-item" href="/">
                      Action
                    </a>
                    <a className="dropdown-item active" href="/">
                      Active item
                    </a>
                    <a className="dropdown-item" href="/">
                      Something else here
                    </a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="/">
                      Separated link
                    </a>
                  </div>
                </div>
                <div className="btn-group dropup">
                  <button
                    type="button"
                    className="btn btn-secondary dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Dropup
                  </button>
                  <div className="dropdown-menu">
                    <a className="dropdown-item" href="/">
                      Action
                    </a>
                    <a className="dropdown-item" href="/">
                      Another action
                    </a>
                    <a className="dropdown-item" href="/">
                      Something else here
                    </a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="/">
                      Separated link
                    </a>
                  </div>
                </div>
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-secondary dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Dropdown scroll
                  </button>

                  <div className="dropdown-menu">
                    <div>
                      <a className="dropdown-item" href="/">
                        Scroll dropdown
                      </a>
                      <a className="dropdown-item" href="/">
                        Another action
                      </a>
                      <a className="dropdown-item" href="/">
                        Something else here
                      </a>
                      <a className="dropdown-item" href="/">
                        Action
                      </a>
                      <a className="dropdown-item" href="/">
                        Another action
                      </a>
                      <a className="dropdown-item" href="/">
                        Something else here
                      </a>
                      <a className="dropdown-item" href="/">
                        Action
                      </a>
                      <a className="dropdown-item" href="/">
                        Another action
                      </a>
                      <a className="dropdown-item" href="/">
                        Something else here
                      </a>
                      <a className="dropdown-item" href="/">
                        Action
                      </a>
                      <a className="dropdown-item" href="/">
                        Another action
                      </a>
                      <a className="dropdown-item" href="/">
                        Something else here
                      </a>
                      <a className="dropdown-item" href="/">
                        Action
                      </a>
                      <a className="dropdown-item" href="/">
                        Another action
                      </a>
                      <a className="dropdown-item" href="/">
                        Something else here
                      </a>
                      <a className="dropdown-item" href="/">
                        Action
                      </a>
                      <a className="dropdown-item" href="/">
                        Another action
                      </a>
                      <a className="dropdown-item" href="/">
                        Something else here
                      </a>
                    </div>
                  </div>
                </div>
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-secondary dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Drop right
                  </button>
                  <div className="dropdown-menu dropdown-menu-right">
                    <a className="dropdown-item" href="/">
                      Action
                    </a>
                    <a className="dropdown-item" href="/">
                      Another action
                    </a>
                    <a className="dropdown-item" href="/">
                      Something else here
                    </a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="/">
                      Separated link
                    </a>
                  </div>
                </div>
              </div>

              <h4>Button sizes</h4>
              <div className="mb-3 demo-child">
                <button type="button" className="btn btn-primary btn-lg">
                  Large button
                </button>
                <button type="button" className="btn btn-primary">
                  Default button
                </button>
                <button type="button" className="btn btn-primary btn-sm">
                  Small button
                </button>
                <button type="button" className="btn btn-primary btn-xs">
                  XS button
                </button>
              </div>

              <h4>Button validation</h4>
              <div className="mb-3 demo-child">
                <button type="button" className="btn btn-warning">
                  Warning
                </button>
                <button type="button" className="btn btn-danger">
                  Danger
                </button>
                <button type="button" className="btn btn-success">
                  Success
                </button>
              </div>
            </div>
            <div className="col-xl-4">
              <h4>Button block</h4>
              <div className="mb-3">
                <button
                  type="button"
                  className="btn btn-secondary btn-lg btn-block"
                >
                  Block level button
                </button>
              </div>

              <h4>Button group</h4>
              <p className="btn-group">
                <a href="/" className="btn btn-secondary">
                  <i className="fa fa-angle-left fa-lg" aria-hidden="true"></i>
                  Left
                </a>
                <a href="/" className="btn btn-secondary">
                  Middle
                </a>
                <a href="/" className="btn btn-secondary">
                  Right
                  <i
                    className="fa fa-right fa-angle-right fa-lg"
                    aria-hidden="true"
                  ></i>
                </a>
              </p>

              <h4>Button group vertical</h4>
              <div className="mb-3 btn-group-vertical">
                <button type="button" className="btn btn-secondary">
                  Button
                </button>
                <button type="button" className="btn btn-secondary">
                  Button
                </button>
                <button type="button" className="btn btn-secondary">
                  Button
                </button>
                <button type="button" className="btn btn-secondary">
                  Button
                </button>
              </div>

              <h4>Button toolbar</h4>
              <div className="mb-3">
                <div className="btn-group">
                  <button type="button" className="btn btn-secondary">
                    1
                  </button>
                </div>
                <div className="btn-group">
                  <button type="button" className="btn btn-secondary">
                    2
                  </button>
                  <button type="button" className="btn btn-secondary">
                    3
                  </button>
                  <button type="button" className="btn btn-secondary">
                    4
                  </button>
                </div>
                <div className="btn-group">
                  <button type="button" className="btn btn-secondary">
                    5
                  </button>
                  <button type="button" className="btn btn-secondary">
                    6
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col">
              <h2 id="forms">Forms</h2>
              <p>
                Remember, all inputs must have a <code>type</code> attribute and
                class <code>form-control</code>
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <form>
                <fieldset>
                  <h4>Input</h4>
                  <div className="form-group row">
                    <label
                      htmlFor="example-text-input"
                      className="col-4 col-form-label text-right"
                    >
                      Text
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="text"
                        autoComplete="off"
                        spellCheck="false"
                        placeholder="The placeholder"
                        defaultValue=""
                        id="example-text-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-search-input"
                      className="col-4 col-form-label text-right"
                    >
                      Search
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="search"
                        placeholder="The placeholder"
                        autoComplete="off"
                        spellCheck="false"
                        defaultValue=""
                        id="example-search-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-email-input"
                      className="col-4 col-form-label text-right"
                    >
                      Email
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="email"
                        defaultValue="test@example.com"
                        id="example-email-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-url-input"
                      className="col-4 col-form-label text-right"
                    >
                      URL
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="url"
                        defaultValue="https://www.w3.org"
                        id="example-url-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-tel-input"
                      className="col-4 col-form-label text-right"
                    >
                      Telephone
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="tel"
                        defaultValue="1-(555)-555-5555"
                        id="example-tel-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-password-input"
                      className="col-4 col-form-label text-right"
                    >
                      Password
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="password"
                        defaultValue="hunter2"
                        id="example-password-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-number-input"
                      className="col-4 col-form-label text-right"
                    >
                      Number
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="number"
                        defaultValue="42"
                        id="example-number-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-datetime-local-input"
                      className="col-4 col-form-label text-right"
                    >
                      Date and time
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="datetime-local"
                        defaultValue="2016-08-19T13:45:00"
                        id="example-datetime-local-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-date-input"
                      className="col-4 col-form-label text-right"
                    >
                      Date
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="date"
                        defaultValue="2016-08-19"
                        id="example-date-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-month-input"
                      className="col-4 col-form-label text-right"
                    >
                      Month
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="month"
                        defaultValue="2016-08"
                        id="example-month-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-week-input"
                      className="col-4 col-form-label text-right"
                    >
                      Week (not ios)
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="week"
                        defaultValue="2016-W33"
                        id="example-week-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="example-time-input"
                      className="col-4 col-form-label text-right"
                    >
                      Time
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        type="time"
                        defaultValue="13:45:00"
                        id="example-time-input"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="textArea"
                      className="col-4 col-form-label text-right"
                    >
                      Textarea
                    </label>
                    <div className="col-8 p-0">
                      <textarea
                        className="form-control"
                        rows="3"
                        id="textArea"
                        placeholder="The placeholder"
                      ></textarea>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="exampleSelect1"
                      className="col-4 col-form-label text-right"
                    >
                      Select
                    </label>
                    <div className="col-8 p-0">
                      <select className="form-control" id="exampleSelect1">
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="exampleSelect2"
                      className="col-4 col-form-label text-right"
                    >
                      Multiple select
                    </label>
                    <div className="col-8 p-0">
                      <select
                        multiple
                        className="form-control"
                        id="exampleSelect2"
                      >
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-4 col-form-label text-right">
                      File browser
                    </label>
                    <div className="col-8 p-0">
                      <div className="file-browser input-group">
                        <label className="input-group-prepend input-group-btn">
                          <span className="btn btn-primary">
                            Browse&hellip;{" "}
                            <input type="file" className="d-none" multiple />
                          </span>
                        </label>
                        <input type="text" className="form-control" readOnly />
                      </div>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-4 col-form-label text-right">
                      Checkbox
                    </label>
                    <div className="col-8 p-0">
                      <div className="check">
                        <input
                          type="checkbox"
                          id="check1"
                          defaultValue="option1"
                          defaultChecked
                        />
                        <label htmlFor="check1">Checkbox one</label>
                      </div>
                      <div className="check">
                        <input
                          type="checkbox"
                          id="check2"
                          defaultValue="option2"
                        />
                        <label htmlFor="check2">Checkbox two</label>
                      </div>
                      <div className="check">
                        <input
                          type="checkbox"
                          id="blankCheckbox"
                          defaultValue="option3"
                        />
                        <label htmlFor="blankCheckbox"></label>
                      </div>
                      <div className="check disabled">
                        <input
                          type="checkbox"
                          id="check4"
                          defaultValue="option4"
                          disabled
                        />
                        <label htmlFor="check4">Checkbox disabled</label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-4 col-form-label text-right">
                      Radio
                    </label>
                    <div className="col-8 p-0 pb-3">
                      <div className="radio">
                        <input
                          type="radio"
                          name="exampleRadios"
                          id="exampleRadios1"
                          defaultValue="option1"
                          defaultChecked
                        />
                        <label htmlFor="exampleRadios1">Radio one</label>
                      </div>
                      <div className="radio">
                        <input
                          type="radio"
                          name="exampleRadios"
                          id="exampleRadios2"
                          defaultValue="option2"
                        />
                        <label htmlFor="exampleRadios2">Radio two</label>
                      </div>
                      <div className="radio">
                        <input
                          type="radio"
                          name="exampleRadios"
                          id="exampleRadios3"
                          defaultValue="option3"
                        />
                        <label htmlFor="exampleRadios3"></label>
                      </div>
                      <div className="radio disabled">
                        <input
                          type="radio"
                          name="exampleRadios"
                          id="exampleRadios4"
                          defaultValue="option4"
                          disabled
                        />
                        <label htmlFor="exampleRadios4">Radio disabled</label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      htmlFor="readOnlyTextInput"
                      className="col-4 col-form-label text-right"
                    >
                      readOnly input
                    </label>
                    <div className="col-8 p-0">
                      <input
                        className="form-control"
                        id="readOnlyTextInput"
                        type="text"
                        placeholder="readOnly input"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="disabledTextInput"
                      className="col-4 col-form-label text-right"
                    >
                      Disabled input
                    </label>
                    <div className="col-8 p-0">
                      <input
                        type="text"
                        id="disabledTextInput"
                        className="form-control"
                        placeholder="Disabled input"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="disabledSelect"
                      className="col-4 col-form-label text-right"
                    >
                      Disabled select
                    </label>
                    <div className="col-8 p-0">
                      <select
                        id="disabledSelect"
                        className="form-control"
                        disabled
                      >
                        <option>Disabled select</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col p-0 text-right">
                      <div className="btn-group">
                        <button type="button" className="btn btn-secondary">
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
            <div className="col-lg-6">
              <form>
                <fieldset>
                  <h4>Input-group, sizes and addons</h4>

                  <div className="form-group">
                    <div className="input-group input-group-lg">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fa fa-group" aria-hidden="true"></i>
                        </span>
                      </div>
                      <input
                        className="form-control"
                        type="text"
                        autoComplete="off"
                        spellCheck="false"
                        placeholder="Large input"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="button">
                          Button
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fa fa-user" aria-hidden="true"></i>
                        </span>
                      </div>
                      <input
                        className="form-control"
                        type="text"
                        autoComplete="off"
                        spellCheck="false"
                        placeholder="Default input"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="button">
                          Button
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="input-group input-group-sm">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fa fa-rocket" aria-hidden="true"></i>
                        </span>
                      </div>
                      <input
                        className="form-control"
                        type="text"
                        autoComplete="off"
                        spellCheck="false"
                        placeholder="Small input"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="button">
                          Button
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <select className="form-control form-control-lg">
                      <option>Large select</option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <select className="form-control">
                      <option>Default select</option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <select className="form-control form-control-sm">
                      <option>Small select</option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                    </select>
                  </div>
                </fieldset>
              </form>

              <form>
                <fieldset>
                  <h4>Validation</h4>
                  <div className="form-group has-warning">
                    <label htmlFor="inputWarning1">Input with warning</label>
                    <input
                      type="text"
                      className="form-control form-control-warning"
                      id="inputWarning1"
                    />
                    <div className="form-control-feedback">
                      Warning, check and try again.
                    </div>
                    <small className="form-text text-muted">
                      Example help text that remains unchanged.
                    </small>
                  </div>
                  <div className="form-group has-danger">
                    <label htmlFor="inputDanger1">Input with danger</label>
                    <input
                      type="text"
                      className="form-control form-control-danger"
                      id="inputDanger1"
                    />
                    <div className="form-control-feedback">
                      Something went wrong, please try again.
                    </div>
                    <small className="form-text text-muted">
                      Example help text that remains unchanged.
                    </small>
                  </div>
                  <div className="form-group has-success">
                    <label htmlFor="inputSuccess1">Input with success</label>
                    <input
                      type="text"
                      className="form-control form-control-success"
                      id="inputSuccess1"
                    />
                    <div className="form-control-feedback">
                      Success, youve done it.
                    </div>
                    <small className="form-text text-muted">
                      Example help text that remains unchanged.
                    </small>
                  </div>

                  <div className="form-group">
                    <div className="check has-warning">
                      <input
                        type="checkbox"
                        id="checkboxWarning"
                        defaultValue="option1"
                      />
                      <label htmlFor="checkboxWarning">Checkbox warning</label>
                    </div>
                    <div className="check has-danger">
                      <input
                        type="checkbox"
                        id="checkboxDanger"
                        defaultValue="option1"
                      />
                      <label htmlFor="checkboxDanger">Checkbox danger</label>
                    </div>
                    <div className="check has-success">
                      <input
                        type="checkbox"
                        id="checkboxSuccess"
                        defaultValue="option1"
                      />
                      <label htmlFor="checkboxSuccess">Checkbox success</label>
                    </div>
                  </div>
                </fieldset>

                <fieldset>
                  <h4>Alerts</h4>
                  <div className="alert alert-warning" role="alert">
                    <button
                      type="button"
                      className="close close-sm"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span>Close</span>
                    </button>
                    <strong>Warning!</strong> Check and try again.{" "}
                    <a href="/">Here is a link</a>
                  </div>
                  <div className="alert alert-danger" role="alert">
                    <button
                      type="button"
                      className="close close-sm"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span>Close</span>
                    </button>
                    <strong>Danger!</strong> Something went wrong, please try
                    again.
                  </div>
                  <div className="alert alert-success" role="alert">
                    <button
                      type="button"
                      className="close close-sm"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span>Close</span>
                    </button>
                    <strong>Success!</strong> You are successfull.
                  </div>
                </fieldset>
              </form>

              <h4>Badge</h4>
              <p className="demo-child">
                <span className="badge badge-default">Default</span>
                <span className="badge badge-primary">Primary</span>
                <span className="badge badge-info">Info</span>
                <span className="badge badge-warning">Warning</span>
                <span className="badge badge-danger">Danger</span>
                <span className="badge badge-success">Success</span>
              </p>
              <h4>Badge pill</h4>
              <p className="mb-4 demo-child">
                <span className="badge badge-pill badge-default">Default</span>
                <span className="badge badge-pill badge-primary">Primary</span>
                <span className="badge badge-pill badge-info">Info</span>
                <span className="badge badge-pill badge-warning">Warning</span>
                <span className="badge badge-pill badge-danger">Danger</span>
                <span className="badge badge-pill badge-success">Success</span>
              </p>
              <h4>Badge pill small</h4>
              <p className="mb-4 demo-child">
                <span className="badge badge-pill badge-sm badge-default">
                  0
                </span>
                <span className="badge badge-pill badge-sm badge-primary">
                  1
                </span>
                <span className="badge badge-pill badge-sm badge-info">2</span>
                <span className="badge badge-pill badge-sm badge-warning">
                  3
                </span>
                <span className="badge badge-pill badge-sm badge-danger">
                  4
                </span>
                <span className="badge badge-pill badge-sm badge-success">
                  5
                </span>
              </p>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col">
              <h2 id="well">Well</h2>
              <p>A well is a content container.</p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4">
              <div className="well well-primary">
                <h4>Well primary</h4>
                <p>
                  Look, Im in a well, with a <a href="/">link</a>. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="well well-secondary">
                <h4>Well</h4>
                <p>
                  Look, Im in a well, with a <a href="/">link</a>. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="well well-info">
                <h4>Well info</h4>
                <p>
                  Look, Im in a well, with a <a href="/">link</a>. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua.
                </p>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col">
              <h2 id="card">Card</h2>
              <p>
                A card is a flexible and extensible content container. It
                includes options for headers and footers, a wide variety of
                content, contextual background colors, and powerful display
                options. Read more about{" "}
                <a
                  href="https://getbootstrap.com/docs/4.3/components/card/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  cards
                </a>
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-6 col-lg-3">
              <div className="card">
                <figure>
                  <img src="https://picsum.photos/600/338?grayscale" alt="" />
                </figure>
                <div className="card-body">
                  <h4 className="card-title">Card</h4>
                  <p className="card-text">
                    Some quick lorem ipsum example text to build on the card
                    title and make up the bulk of the cards content.
                  </p>
                </div>
                <div className="card-footer">
                  <a href="/" className="btn btn-primary">
                    <i className="fa fa-rocket" aria-hidden="true"></i>Lorem
                    ipsum
                    <i
                      className="fa fa-angle-right fa-lg"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div className="card">
                <figure>
                  <img src="https://picsum.photos/600/338?grayscale" alt="" />
                </figure>
                <div className="card-body">
                  <h4 className="card-title">Card</h4>
                  <p className="card-text">
                    Some quick lorem ipsum example text to build on the card
                    title and make up the bulk of the cards content.
                  </p>
                </div>
                <div className="card-footer">
                  <a href="/" className="btn btn-primary">
                    <i className="fa fa-rocket" aria-hidden="true"></i>Lorem
                    ipsum
                    <i
                      className="fa fa-angle-right fa-lg"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div className="card">
                <figure>
                  <img src="https://picsum.photos/600/338?grayscale" alt="" />
                </figure>
                <div className="card-body">
                  <h4 className="card-title">Card</h4>
                  <p className="card-text">
                    Some quick lorem ipsum example text to build on the card
                    title and make up the bulk of the cards content.
                  </p>
                </div>
                <div className="card-footer">
                  <a href="/" className="btn btn-primary">
                    <i className="fa fa-rocket" aria-hidden="true"></i>Lorem
                    ipsum
                    <i
                      className="fa fa-angle-right fa-lg"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div className="card">
                <figure>
                  <img src="https://picsum.photos/600/338?grayscale" alt="" />
                </figure>
                <div className="card-body">
                  <h4 className="card-title">Card</h4>
                  <p className="card-text">
                    Some quick lorem ipsum example text to build on the card
                    title and make up the bulk of the cards content.
                  </p>
                </div>
                <div className="card-footer">
                  <a href="/" className="btn btn-primary">
                    <i className="fa fa-rocket" aria-hidden="true"></i>Lorem
                    ipsum
                    <i
                      className="fa fa-angle-right fa-lg"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col">
              <h2 id="components">Components</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4">
              <div className="well">
                <h4 id="modal">Modals</h4>
                <p>
                  Read more about{" "}
                  <a
                    href="https://getbootstrap.com/docs/4.3/components/modal/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    modals
                  </a>
                </p>

                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-toggle="modal"
                  data-target="#standardModal"
                >
                  Standard modal
                </button>

                <div
                  className="modal fade"
                  id="standardModal"
                  role="dialog"
                  aria-labelledby="standardModalLabel"
                  data-animation="false"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          data-keyboard="true"
                          aria-label="Close"
                        >
                          <span>Close</span>
                        </button>
                        <h4 className="modal-title" id="standardModalLabel">
                          Modal title
                        </h4>
                      </div>
                      <div className="modal-body">
                        <div className="dialog">
                          <div className="dialog-body">
                            <h5>
                              <i
                                className="fa fa-exclamation-triangle"
                                aria-hidden="true"
                              ></i>
                              This is a standard modal with a dialog message.
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button type="button" className="btn btn-primary">
                          Do something
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-toggle="modal"
                  data-target="#pageModal"
                >
                  Page modal
                </button>

                <div
                  className="modal modal-page fade"
                  id="pageModal"
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="pageModalLabel"
                  data-animation="false"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="container">
                          <div className="row">
                            <div className="col">
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                data-keyboard="true"
                                aria-label="Close"
                              >
                                <span>Close</span>
                              </button>
                              <h4 className="modal-title" id="pageModalLabel">
                                Modal title
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-body">
                        <div className="container">
                          <div className="row">
                            <div className="col">
                              <h2>This is a page modal</h2>
                              <h4>Bootstrap history</h4>
                              <p className="lead">
                                Originally created by a designer and a developer
                                at Twitter, Bootstrap has become one of the most
                                popular front-end frameworks and open source
                                projects in the world.
                              </p>
                              <p>
                                Lorem ipsum har inte bara överlevt fem
                                århundraden, utan även övergången till
                                elektronisk typografi utan större förändringar.
                                Det blev allmänt känt på 1960-talet i samband
                                med lanseringen av Letraset-ark med avsnitt av
                                Lorem Ipsum, och senare med mjukvaror som Aldus
                                PageMaker.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-backdrop="false"
                  data-toggle="modal"
                  data-target="#resizeDraggableModal"
                >
                  Modal resizable &amp; draggable
                </button>
                <div
                  className="modal-resize-draggable fade"
                  id="resizeDraggableModal"
                  role="dialog"
                  aria-labelledby="resizeDraggableModalLabel"
                  data-animation="false"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          data-keyboard="true"
                        ></button>
                        <h4
                          className="modal-title"
                          id="resizeDraggableModalLabel"
                        >
                          Modal resizable draggable title
                        </h4>
                      </div>
                      <div className="modal-body">
                        <div className="dialog">
                          <div className="dialog-body">
                            <h5>
                              <i
                                className="fa fa-arrows"
                                aria-hidden="true"
                              ></i>
                              This is a resizable draggable modal.
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button type="button" className="btn btn-primary">
                          Do something
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-backdrop="false"
                  data-toggle="modal"
                  data-target="#rightResizeDraggableModal"
                >
                  Modal small & right
                </button>
                <div
                  className="modal modal-resize-draggable modal-right fade"
                  id="rightResizeDraggableModal"
                  role="dialog"
                  aria-labelledby="rightResizeDraggableModalLabel"
                  data-animation="false"
                >
                  <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          data-keyboard="true"
                        ></button>
                        <h4
                          className="modal-title"
                          id="rightResizeDraggableModalLabel"
                        >
                          Modal small right
                        </h4>
                      </div>
                      <div className="modal-body">
                        <div className="dialog">
                          <div className="dialog-body">
                            <h5>
                              <i
                                className="fa fa-arrows"
                                aria-hidden="true"
                              ></i>
                              This is a small modal.
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button type="button" className="btn btn-primary">
                          Do something
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="well">
                <h4 id="progress">Toast message</h4>
                <div aria-live="polite" aria-atomic="true">
                  <div
                    className="toast show"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                  >
                    <div className="toast-header">
                      <strong className="mr-auto">Message</strong>
                      <small className="text-muted">just now</small>
                      <button
                        type="button"
                        className="close close-white close-sm"
                        data-dismiss="toast"
                        aria-label="Close"
                      >
                        <span>Close</span>
                      </button>
                    </div>
                    <div className="toast-body">See? Just like this.</div>
                  </div>

                  <div
                    className="toast show"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                  >
                    <div className="toast-header">
                      <strong className="mr-auto">Message</strong>
                      <small className="text-muted">2 seconds ago</small>
                      <button
                        type="button"
                        className="close close-white close-sm"
                        data-dismiss="toast"
                        aria-label="Close"
                      >
                        <span>Close</span>
                      </button>
                    </div>
                    <div className="toast-body">
                      Heads up, toasts will stack automatically
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="well">
                <h4 id="popover">Popovers</h4>
                <p>
                  Read more about{" "}
                  <a
                    href="https://getbootstrap.com/docs/4.3/popovers/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    popovers
                  </a>
                </p>

                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-container="body"
                  data-toggle="popover"
                  data-placement="top"
                  title="Popover top"
                  data-content="Popover on top"
                >
                  Popover on top
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-container="body"
                  data-toggle="popover"
                  data-placement="right"
                  title="Popover right"
                  data-content="Popover on right"
                >
                  Popover on right
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-container="body"
                  data-toggle="popover"
                  data-placement="left"
                  title="Popover left"
                  data-content="Popover on left"
                >
                  Popover on left
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-container="body"
                  data-toggle="popover"
                  data-placement="bottom"
                  title="Popover bottom"
                  data-content="Popover on bottom"
                >
                  Popover on bottom
                </button>
              </div>

              <div className="well">
                <h4 id="collapse">Collapse</h4>
                <p>
                  Read more about{" "}
                  <a
                    href="https://getbootstrap.com/docs/4.3/components/collapse/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    collapse
                  </a>
                </p>
                <button
                  type="button"
                  className="btn btn-primary btn-collapse"
                  data-toggle="collapse"
                  data-target="#collapseExample"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  Button collapse
                </button>
                <div className="collapse" id="collapseExample">
                  <div className="mt-4 mb-2">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="well">
                <h4 id="tooltip">Tooltips</h4>
                <p>
                  Read more about{" "}
                  <a
                    href="https://getbootstrap.com/docs/4.3/tooltips/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    tooltips
                  </a>
                </p>

                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Tooltip on top"
                >
                  Tooltip on top
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="Tooltip on right"
                >
                  Tooltip on right
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-toggle="tooltip"
                  data-placement="left"
                  title="Tooltip on left"
                >
                  Tooltip on left
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-block mb-2"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Tooltip on bottom"
                >
                  Tooltip on bottom
                </button>
              </div>
            </div>
          </div>

          <footer className="pt-5 pb-5 text-center">
            <h5>The end</h5>
          </footer>
        </section>
      </>
    );
  }
}

export default BootstrapPage;
